import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import _logger from "./services/logService";

_logger.init();

Modal.setAppElement("#root");

ReactDOM.render(<App />, document.getElementById("root"));
